
export default function filterCond(fieldName, values, toSplit) {
    if (values) {
        if (toSplit) {
            values = values.split(',');
        }
        if (values.length > 0) {
            let delemeter = getNonExistString(values);
            let hasEmpty = false;
            values = values.map((value) => {
                //hasEmptyの場合配列から要素を減らすべきだが、結果が変わらないので端折っている
                //(なお、現状は空白のfacetは事前に含まれないようにしているため、hasEmptyを通ることはない)
                if (!value) hasEmpty = true;
                return encodeURI(value.replace("'", "''"));
            });

            let searchin = `search.in(${fieldName},'${values.join(delemeter)}','${delemeter}')`;
            return hasEmpty ? ` and (${fieldName} eq '' or ${searchin})` : ` and ${searchin}`
        }
    }
    return '';
}
function getNonExistString(values) {
    let text = '|';
    while (includeIn(values, text)){
        text += '|';
    }
    return text;
}
function includeIn(values, text) {
    for (let i = 0; i < values.length; i++) {
        if (values[i].includes(text))
            return true;
    }
    return false;

}
